<!--
 * @Description:
 * @Author: luokang
 * @Date: 2023-06-26 13:48:02
-->
<template>
<div></div>
</template>

<script>
import * as Api from '@api/base/public'
export default {
  name: 'Transfer',
  data() {
    return {
      shop: ''
    }
  },
  async created() {
    const { hmac = '', shop = '', host = '' } = this.$route.query
    if (hmac && shop && host) {
      this.shop = shop.replace('.myshopify.com', '')
      const shopifyAuthTime = sessionStorage.getItem('shopifyAuthTime')
      if (shopifyAuthTime && new Date().getTime() - shopifyAuthTime <= 3000) {
        // 5s内重复请求就结束
        return false
      }
      sessionStorage.setItem('shopifyAuthTime', new Date().getTime())
      const res = await this.shopifyCheckSign(this.$route.query)
      if (!res) {
        // 校验失败  请求真实性异常
        this.$message.error('invalid request')
        location.href = `https://${shop}`
      }
    }
    this.init()
  },
  methods: {
    async shopifyCheckSign(params) {
      const { data = false } = await Api.shopifyCheckSign(params)
      return data
    },
    // 初始化
    init() {
      // shopify 生产使用key
      let id = '24c9d2d2dafffa030e6f12116039876f'
      if (location.host !== 'vip.jtjms-sa.com') {
        // shopify 非生产使用key
        id = '059ed117150f68b2cfdbfd926ed5c643'
      }
      console.log(this.shop)
      location.href = `https://${this.shop}.myshopify.com/admin/oauth/authorize?client_id=${id}&scope=write_orders,write_fulfillments,write_shipping,write_merchant_managed_fulfillment_orders,write_third_party_fulfillment_orders,write_assigned_fulfillment_orders&redirect_uri=${
        location.origin
      }/shopifylogin`
    },
  },
}
</script>

<style>

</style>
